import React, {useEffect, useRef, useState} from 'react';
import {convertDate, formatUtcIso} from "../../../../utils/helpers/formatTime";
import s from "../subscriptionsAccounting.module.scss";
import MuiTooltip from "../../../../components/UiKit/MuiTooltip/MuiTooltip";
import SvgSelector from "../../../../components/SvgSelector/SvgSelector";
import SetSubscriptionNotePopup from "./Popups/SetSubscriptionNotePopup/SetSubscriptionNotePopup";
import {useTranslation} from "react-i18next";
import useCustomSnackbar from "../../../../hooks/useCustomSnackbar";
import {snackbar_info} from "../../../../utils/vars/staticVariables";
import {useDispatch, useSelector} from "react-redux";
import SetExtraMarkDetailPopup from "./Popups/SetUniqueExtraMarkPopup/SetExtraMarkDetailPopup";
import ViewSubscriptionHistoryPopup from "./Popups/ViewSubscriptionHistoryPopup/ViewSubscriptionHistoryPopup";
import {subscriptionsAccountingSelector} from "../../../../redux/slices/subscriptionsAccountingSlice";


export const extraMarkRatiosArray = [
    {
        value: 'won_the_contest',
        icon: 'medal-emoji'
    },
    {
        value: 'gift',
        icon: 'gift-emoji'
    },
    {
        value: 'compensation',
        icon: 'flying-money-emoji'
    },
    {
        value: 'other',
        icon: 'recycling-emoji'
    },
    {
        value: 'clear_button',
        icon: 'new-remove-icon'
    },

]

const SubscriptionsAccountingTr = ({
                                       active_by_time,
                                       balance,
                                       buy_date,
                                       email,
                                       extra_mark,
                                       note,
                                       packet_name,
                                       push_date,
                                       renew_subscription,
                                       secret_key,
                                       subscription_history,
                                       subscription_id,
                                       team_name,
                                       extra_mark_detail,
                                       subscription_service_id,
                                       extra_days,

                                       editSubscriptionNote,
                                       setExtraMarkHandler,
                                       visibleColumns,
                                       setExtraMarkDetailHandler
                                   }) => {

    const setExtraMarkPopupRef = useRef(null);

    const [isActiveSetNotePopup, setActiveSetNotePopup] = useState(false);
    const [isActiveSetExtraMarkPopup, setActiveSetExtraMarkPopup] = useState(false);
    const [isExtraMarkDetailPopupActive, setExtraMarkDetailPopupActive] = useState(false);
    const [isViewSubscriptionHistoryPopupActive, setViewSubscriptionHistoryPopupActive] = useState(false);

    const {setExtraMarkPending} = useSelector(subscriptionsAccountingSelector)

    const dispatch = useDispatch();

    const {t} = useTranslation()
    const showSnackbar = useCustomSnackbar();

    useEffect(() => {
        function handleClickOutside(event) {
            if (
                setExtraMarkPopupRef.current &&
                !setExtraMarkPopupRef.current.contains(event.target)
            ) {
                setActiveSetExtraMarkPopup(false);
            }
        }

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [setExtraMarkPopupRef]);

    const copySecretKey = async (secret_key) => {
        if (secret_key) {
            try {
                await navigator.clipboard.writeText(secret_key);
                showSnackbar(t('secret_key_copied'), snackbar_info);
            } catch (err) {
            }
        }

    }

    const extraMarkValue = extraMarkRatiosArray.find(({value}) => value === extra_mark) || undefined

    const isActiveSubscription = packet_name !== 'Installation fee'

    const getClass = (colName) => {
        switch (colName) {
            case 'name_column':
                return null;
            case 'subscription_purchase_date':
                return null;
            case 'extra_days':
                return (
                    `
                    ${s.extraDaysTd}
                        ${extra_days > 0 ? s.red : s.green}
                    `
                )
            case 'push_date':
                return null
            case 'subscription_level':
                return (
                    `
                        ${s.subscriptionNameTd}
                        ${isActiveSetExtraMarkPopup ? s.opened : ''}
                        ${packet_name === 'Test' ? s.test : ''}
                        ${packet_name === 'Wild Star' ? s.wildStar : ''}
                        ${packet_name === 'Android Star' ? s.androidStar : ''}
                        ${packet_name === 'Start' ? s.start : ''}
                        ${packet_name === 'Installation fee' ? s.installationFee : ''}
                    `
                )
            case 'autopay':
                return ` ${s.autoPayTd} ${renew_subscription ? s.green : s.red}`
            case 'balance':
                return null
            case 'email':
                return null
            case 'secret_bot_key':
                return s.secretKeyTd
            case 'notes':
                return s.noteTd
            default:
                return null;
        }
    }

    const renderCell = (colName) => {
        switch (colName) {
            case 'name_column':
                return team_name || '-';
            case 'subscription_purchase_date':
                return buy_date ? convertDate(buy_date, 'DMY') : '-'
            case 'extra_days':
                return extra_days > 0 ? extra_days : t('extra_days_are_not_being_used')
            case 'push_date':
                return (
                    <div className={s.pushDatesContainer}>
                        {
                            push_date.map(date => {
                                const {date: pushDate, time: pushTime} = formatUtcIso(date);

                                return (
                                    <div className={s.pushDateContainer} key={date}>
                                        {pushDate}
                                        {/*<span className={s.pushTime}>{pushTime}</span>*/}
                                    </div>
                                )
                            })
                        }
                    </div>
                );
            case 'subscription_level':
                return (

                    <>
                        <SetExtraMarkDetailPopup
                            active={isExtraMarkDetailPopupActive}
                            setActive={setExtraMarkDetailPopupActive}
                            extraMarkDetail={extra_mark_detail}
                            setExtraMarkDetailHandler={(value) => setExtraMarkDetailHandler(subscription_service_id, value, setExtraMarkDetailPopupActive)}
                        />
                        <div className={s.extraMarkContainer} ref={setExtraMarkPopupRef}>

                            {
                                isActiveSetExtraMarkPopup && <ul className={s.extraMarkOptionsList}>
                                    {
                                        extraMarkRatiosArray.map(({icon, value}) => {

                                            return (
                                                <li key={value}>
                                                    <button
                                                        className={`${s.extraMarkOption} ${extraMarkValue?.value === value ? s.selected : ''}`}
                                                        disabled={setExtraMarkPending}
                                                        onClick={() => {
                                                            setExtraMarkHandler(subscription_service_id, value)
                                                            setActiveSetExtraMarkPopup(false)
                                                        }}
                                                    >
                                                        <SvgSelector id={icon}/>
                                                        <span>{t(value)}</span>
                                                    </button>
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            }


                            <button
                                className={`${s.subscription} ${!isActiveSubscription ? s.noCursor : ''}`}
                                onClick={() => {
                                    if (!isActiveSubscription) return
                                    setActiveSetExtraMarkPopup(v => !v)
                                }}
                            >
                        <span>
                        {
                            !isActiveSubscription ? 'Installation Fee' : packet_name
                        }
                        </span>

                                {
                                    isActiveSubscription && <SvgSelector id='language-dropdown-arrow'/>
                                }
                            </button>

                            {
                                extraMarkValue && isActiveSubscription &&
                                <div className={s.extraMarkWrapper}>
                                    <MuiTooltip title={t(extraMarkValue?.value)}>
                                        <SvgSelector id={extraMarkValue?.icon}/>
                                    </MuiTooltip>
                                </div>
                            }

                            <div>
                                {
                                    <button
                                        className={s.editCustomExtraMark}
                                        onClick={() => setExtraMarkDetailPopupActive(true)}
                                    >
                                        <MuiTooltip title={extra_mark_detail}>
                                            <SvgSelector id="edit-icon"/>
                                        </MuiTooltip>
                                    </button>
                                }
                            </div>

                        </div>
                    </>
                );
            case 'history':
                return (
                    <>
                        <ViewSubscriptionHistoryPopup
                            active={isViewSubscriptionHistoryPopupActive}
                            setActive={setViewSubscriptionHistoryPopupActive}
                            subscription_history={subscription_history}
                        />
                        <button
                            onClick={() => setViewSubscriptionHistoryPopupActive(true)}
                            className={s.subscriptionHistoryButton}
                            disabled={subscription_history?.length === 0}
                        >
                            <MuiTooltip
                                title={t(subscription_history?.length > 0 ? 'view_subscription_history' : 'history_is_empty')}>
                                <SvgSelector id="subscription-history-icon"/>
                            </MuiTooltip>
                        </button>
                    </>
                )
            case 'autopay':
                return t(renew_subscription ? 'on' : 'off')
            case 'balance':
                return `$ ${balance}`
            case 'email':
                return email
            case 'secret_bot_key':
                return (
                    secret_key && <button onClick={() => copySecretKey(secret_key)}>
                        <span className={s.secretKeyValue}>{secret_key}</span>
                        <SvgSelector id="copy-link-icon"/>
                    </button>
                );
            case 'notes':
                return (
                    <>
                        <SetSubscriptionNotePopup
                            active={isActiveSetNotePopup}
                            setActive={setActiveSetNotePopup}
                            subscription_service_id={subscription_service_id}
                            note={note}
                            icon={<SvgSelector id="note-popup-icon"/>}
                            onSetNoteHandler={(form) => editSubscriptionNote(form, setActiveSetNotePopup)}
                        />

                        {
                            <div className={s.editNoteField}>
                                <button
                                    className={s.noteTextBtn}
                                    onClick={() => setActiveSetNotePopup(true)}
                                >
                                    <div className={s.noteText}>{note}</div>
                                    <MuiTooltip title={note}></MuiTooltip>
                                    <SvgSelector id="edit-icon"/>
                                </button>
                            </div>
                        }
                    </>
                );
            default:
                return null;
        }
    };

    return (
        <tr>
            {visibleColumns.map(({name: colName}) => (
                <td key={colName} className={getClass(colName) || ''}>
                    {renderCell(colName)}
                </td>
            ))}
        </tr>
    )
}

export default SubscriptionsAccountingTr;